import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Thumbnail from '../../assets/thumbnails/rapid-boost.jpeg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
// import playlist from '../../mockdata/fundamentals';
import '../../styles/videoplayer.css';
import PlaylistCourse from './PlaylistCourse';


const PlaylistSidebar = ({course, fullAccess}) => {  

    const navigate = useNavigate();

    return (
      <div className="playlist-sidebar">
        <div className="align-items-center d-none d-lg-flex" style={{ borderBottom: "1px solid #AEAFBA", paddingBottom: "5px" }}>
          <div className="d-flex justify-content-start align-items-center" style={{ cursor: "pointer" }}>
            <FontAwesomeIcon icon={faArrowLeftLong} style={{ fontSize: "18px", color: "white" }} onClick={() => navigate('/tutorials/foundation')} />
          </div>
          <h4 className="ms-2">Melee Foundation</h4>
        </div>
        <div className="">
            {course.map((item, index) => (            
                <PlaylistCourse item={item} key={index} fullAccess={fullAccess} />
            ))}
        </div>
      </div>
    );
  };
  
  export default PlaylistSidebar;